/**
 * Trainer availability helpers — exclude the session being rescheduled
 * so it does not conflict with itself.
 */

export type TrainerConflictSession = {
  session_id?: string | number;
  session_title?: string;
  session_starttime?: string;
  session_expected_endtime?: string;
  session_status?: string;
};

export function normalizeSessionTitle(title: string | undefined | null): string {
  return String(title || '').trim().toLowerCase();
}

/** Conflicts that are not the same session title (self / reschedule). */
export function otherTrainerConflicts(
  conflicts: TrainerConflictSession[] | undefined | null,
  sessionTitle: string,
): TrainerConflictSession[] {
  const self = normalizeSessionTitle(sessionTitle);
  const list = Array.isArray(conflicts) ? conflicts : [];
  if (!self) return list;
  return list.filter(
    (c) => normalizeSessionTitle(c.session_title) !== self,
  );
}

/** First conflicting session that shares this title (same session being edited). */
export function findSelfTrainerConflict(
  conflicts: TrainerConflictSession[] | undefined | null,
  sessionTitle: string,
): TrainerConflictSession | null {
  const self = normalizeSessionTitle(sessionTitle);
  if (!self) return null;
  const list = Array.isArray(conflicts) ? conflicts : [];
  return (
    list.find((c) => normalizeSessionTitle(c.session_title) === self) || null
  );
}

export function conflictSessionId(
  conflict: TrainerConflictSession | null | undefined,
): string {
  if (!conflict || conflict.session_id == null) return '';
  return String(conflict.session_id).trim();
}

/** After create, the new session occupies this slot — do not check again. */
export function shouldCheckTrainerAvailability(createdSessionId?: string | number | null): boolean {
  if (createdSessionId == null || createdSessionId === '') return true;
  return String(createdSessionId).trim() === '';
}
